import useFetchHelpCenter from './fetch/useFetchHelpCenter';
import useIsMobile from './useIsMobile';

export default function useAutoOpenDelay(): number {
  const isMobile = useIsMobile();
  const { data: helpCenter } = useFetchHelpCenter();

  return helpCenter?.options?.[isMobile ? 'autoopen_mobile_delay_ms' : 'autoopen_desktop_delay_ms'] ?? 0;
}
